import React from 'react';

import { createScope, partnerCenterTheme } from '@harmony/enablers/react';

import { LayoutElements as LayoutConstants } from '../../Common/Constants/LayoutElements.Constants';

const scope = createScope({
  styles: [partnerCenterTheme],
  rootElement: document.getElementById(LayoutConstants.SupportWorkspace) as HTMLElement,
  reactInstance: React,
  prefix: 'support',
});

export const getHarmonyScope = () => {
  return scope;
};
